import React, { Component } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { Redirect } from 'react-router-dom';
import ReactDragList from 'react-drag-list';
import Loader from 'react-loader';
import SortableTbl from "react-sort-search-table";
import { Animated } from 'react-animated-css';



import Navbar from '../../../../components/CustomNav/CustomNav.Component';
import { Body, Container, BuilderContainer, ScreensList, Row, InputWrapper, DnDContainer, PreviewContainer, PreviewRow, Button, Header, ScreenListItem, NextButton, StyledForm, StyledSelect, StyledOption, FabButton } from '../../LessonBuilder/LessonBuilder.styles';


import delIcon from '../../../../assets/images/lessonbuilder/trash.svg';
import viewIcon from '../../../../assets/images/lessonbuilder/preview.svg';


import withServices from 'src/HOCs/withServices'

import LessonPreviewPage from '../../../SingleLesson/lessonPreviewPage.Component';

// interface Props {
//     services?: any, 
//     history?: any,
//     match?: any
// }
// interface State {
//     toLogin: boolean,
//     lessonName: string,
//     lessonDescription: string,
//     courseLessons: any, 
//     courseLessonsLoaded: boolean,
//     allLessons: any,
//     allLessonsLoaded: boolean
// }

class CourseBuilder extends Component {
    constructor(props) {
        super(props)

        this.state = {
            toLogin: false,
            lessonName: '',
            lessonDescription: '',
            courseLessons: [],
            courseLessonsLoaded: false,
            allLessons: [],
            allLessonsLoaded: false,
            displayOrder: 0,
            currentlySelectedCourse: {},
            currentlySelectedLoaded: false,
            showNewForm: false,
            showInfoForm: false,
            showForm: false
        }

        this.addNewLesson = this.addNewLesson.bind(this);
        this.deleteLesson = this.deleteLesson.bind(this);
        this.onDragComplete = this.onDragComplete.bind(this);
        this.toggleLessonInfoForm = this.toggleLessonInfoForm.bind(this);
        this.updateLessonInfo = this.updateLessonInfo.bind(this);
    }

    async componentDidMount() {
        const { match, services: { isUserLoggedIn, adminAPI } } = this.props;
        const { params: { id: courseID } } = match;
        console.log(this.props)

        const [allLessonsRes, courseLessonsRes] = await Promise.all([adminAPI.getAllLessons(), adminAPI.getCurrentCourseLessons({ courseID })]);
        if (courseLessonsRes.ok) {
            const courseLessons = courseLessonsRes.data.course_lessons;
            const allLessons = allLessonsRes.data.lessons;
            console.log('CourseLEssons: ' + JSON.stringify(courseLessons, null, 2))
            console.log('allLEssons: ' + JSON.stringify(allLessons, null, 2))

            this.setState({
                courseLessons,
                allLessons,
                courseLessonsLoaded: true,
                allLessonsLoaded: true,
                showNewForm: true,
                showForm: true
            })
        }

    }

    async addNewLesson(props, e) {
        // new lesson details coming
        e.preventDefault();
        const { services: { currentUserID, adminAPI }, match } = this.props;
        const { params: { id: courseID } } = match;
        const { lessonName, lessonDescription, displayOrder } = this.state;

        const item = {
            Colour: 'white',
            Course: courseID,
            DisplayOrder: displayOrder,
            User: currentUserID,
            Name: lessonName,
            Lesson: props.rowData.id,
            Description: lessonDescription
        }

        const res = await adminAPI.createItemGeneral('course_lessons', item);
        if (res.ok) {
            toast.success("Lesson Added to Course");
            const courseLessonRes = await this.props.services.adminAPI.getCurrentCourseLessons({ courseID });

            if (courseLessonRes.ok) {

                const courseLessons = courseLessonRes.data.course_lessons;

                this.setState({
                    courseLessons,
                    lessonName: '',
                    lessonDescription: ''
                });
            }
            document.getElementById("lesson-details").reset();

        } else {
            toast.error("Error adding Lesson, check all required details")
        }
    }

    onLogout = () => {
        this.setState({ toLogin: true });
    }
    // onGoBack = () => {
    //     this.props.history.goBack();
    // }

    changeLessonName = (e) => {
        this.setState({ lessonName: e.target.value });
    }
    changeLessonDescription = e => {
        this.setState({ lessonDescription: e.target.value });
    }

    async onDragComplete() {
        const item = {
            DisplayItems: JSON.stringify(this.state.courseLessons)
        }
        const res = await this.props.services.adminAPI.updateCourseLessonOrder(item);

        if (res.ok) {
            const courseID = this.props.match.params.id;
            const courseLessonRes = await this.props.services.adminAPI.getCurrentCourseLessons({ courseID });

            if (courseLessonRes.ok) {

                const courseLessons = courseLessonRes.data.course_lessons;

                this.setState({
                    courseLessons
                });
                toast.success("Lesson Order Updated");
            }
        }
        else {
            toast.error('Error updating order!');
        }

        // screens drag complete
    }

    async deleteLesson(lessonID) {
        const retVal = confirm("Do you want to continue ?");
        if (!retVal) {
            return;
        }
        this.setState({ courseLessonsLoaded: false })
        const res = await this.props.services.adminAPI.deleteItemGeneral('course_lessons', lessonID);
        if (res.ok) {
            toast.success("Lesson Deleted!");
            const { params: { id: courseID } } = this.props.match;
            const courseLessonRes = await this.props.services.adminAPI.getCurrentCourseLessons({ courseID });
            if (courseLessonRes.ok) {
                const courseLessons = courseLessonRes.data.course_lessons;

                this.setState({
                    courseLessons,
                    courseLessonsLoaded: true
                });
            }
        } else {
            toast.error("Could Not Delete Lesson!")
        }
    }

    previewLesson = (lessonID) => {
        const { history } = this.props;
        history.push(`/admins/lessonpreview/${+lessonID}`);
    }

    toggleNewLessonForm = () => {
        this.setState({ showForm: false });
        setTimeout(() => {
            this.setState({ showNewForm: true, showForm: true, showInfoForm: false });

        }, 1000)
    }

    async toggleLessonInfoForm(lessonID) {
        this.setState({ currentlySelectedLoaded: false, showForm: false })
        const id = +lessonID
        const res = await this.props.services.adminAPI.getSingleItemGeneral('course_lessons', id);
        if (res.ok) {
            const currentlySelectedCourse = res.data;
            // console.log("LessInfo: " + JSON.stringify(currentlySelectedCourse, null, 2))
            this.setState({ currentlySelectedCourse, currentlySelectedLoaded: true, showNewForm: false, showInfoForm: true, showForm: true, lessonName: currentlySelectedCourse.Name, lessonDescription: currentlySelectedCourse.Description });

        } else {
            toast.error("Error Fetching Details");
        }
    }

    async updateLessonInfo(e) {
        e.preventDefault();
        const { currentlySelectedCourse, lessonName, lessonDescription } = this.state;
        // console.log("LessInfo2: " + JSON.stringify(currentlySelectedCourse, null, 2));
        const item = {
            ...currentlySelectedCourse,
            Name: lessonName,
            Description: lessonDescription
        }
        const res = await this.props.services.adminAPI.updateItemGeneral('course_lessons', item, item.CourseLessonId);
        if (res.ok) {
            const courseID = this.props.match.params.id;
            const courseLessonRes = await this.props.services.adminAPI.getCurrentCourseLessons({ courseID });

            if (courseLessonRes.ok) {

                const courseLessons = courseLessonRes.data.course_lessons;

                this.setState({
                    courseLessons
                });
                toast.success("Lesson Info Updated");
            }
            toast.success('Update Successful');
        }
        else {
            toast.error('Update Failed')
        }
    }

    getLessonStatus = (rowData) => {
        const { courseLessons } = this.state;
        const exists = courseLessons.find(item => item.Lesson === rowData.id);
        console.log("CourseLessons: " + JSON.stringify(exists));
        if(exists && typeof exists !== 'undefined') {
        return <p style={{fontSize: '12px', color: '#ff0033', textAlign: 'center'}}>Already Added: {exists.Title}</p>
        }else {
            return <p style={{ fontSize: '12px', color: '#acff24', textAlign: 'center' }}>Not Added</p>
        }
    }

    renderCustomTD = props => {
        console.log("PROS: " + JSON.stringify(props, null, 2));
        return (
            <td>
                {/*tslint:disable-next-line jsx-no-lambda*/}
                <button type="submit" style={{ margin: '3px' }} className="blue-button view-more-data table-action" onClick={(e) => this.addNewLesson(props, e)}>Add to Course</button>
                {this.getLessonStatus(props.rowData)}
                {/* <p>Selected</p> */}
            </td>
        );
    }

    renderLessonsList = () => {
        const { courseLessons, courseLessonsLoaded } = this.state;
        console.log("B4 Drag: " + JSON.stringify(courseLessons, null, 2));

        if (courseLessonsLoaded) {
            return (
                <ReactDragList
                    dataSource={courseLessons}
                    rowKey="id"
                    row={(lesson, idx) =>
                        <ScreenListItem key={`course-lesson-${idx}`} bgColor="#467d74" onClick={this.toggleLessonInfoForm.bind(this, lesson.id)}>
                            <p>{lesson.Title}</p>
                            <div>
                                <img src={viewIcon} height="20px" onClick={this.previewLesson.bind(this, lesson.Lesson)} />
                                <img src={delIcon} onClick={this.deleteLesson.bind(this, lesson.id)} />
                            </div>
                        </ScreenListItem>
                    }
                    handles={false}
                    className='simple-drag'
                    rowClassName='simple-drag-row'
                    onUpdate={this.onDragComplete}
                >
                </ReactDragList>
            )
        } else {
            return '';
        }
    }

    renderNewLessonForm = () => {
        const { allLessons, allLessonsLoaded } = this.state;
        if (allLessonsLoaded) {
            return (
                <StyledForm onSubmit={this.addNewLesson} id="lesson-details">
                    <Row>
                        <InputWrapper cols={1}>
                            <p>Lesson Name*</p>
                            <input
                                className="custom-textfield lb-textfield"
                                type="text"
                                name="lesson_name"
                                id="display-order"
                                placeholder="Lesson Name"
                                data-arg="lesson-name"
                                required={true}
                                onChange={this.changeLessonName}
                            />
                        </InputWrapper>
                    </Row>
                    <Row>
                        <InputWrapper cols={1}>
                            <p>Display Order*</p>
                            <input
                                className="custom-textfield lb-textfield"
                                type="number"
                                name="display_order"
                                id="display-order"
                                placeholder="0: dont change value"
                                data-arg="display-order"
                                contentEditable={false}
                            />
                        </InputWrapper>
                    </Row>
                    <Row>
                        <InputWrapper cols={1}>
                            <p>Description*</p>
                            <textarea
                                name="title"
                                id="title"
                                cols={30}
                                rows={4}
                                className="custom-textfield lb-textfield"
                                style={{ height: "100px" }}
                                placeholder="Lesson Description"
                                data-arg="description"
                                onChange={this.changeLessonDescription}
                                required = {true}
                            />
                        </InputWrapper>
                    </Row>
                    <Row>
                        <SortableTbl
                            tblData={allLessons}
                            tHead={["ID", "Title", "Description", "Action"]}
                            dKey={["id", "Title", "Description", "add"]}
                            customTd={[
                                { custd: this.renderCustomTD, keyItem: "add", sortable: false },

                            ]}
                            defaultCSS={false}
                        />
                    </Row>
                </StyledForm>
            )
        } else {
            return '';
        }
    }

    renderLessonInfoForm = () => {
        const { currentlySelectedCourse, currentlySelectedLoaded } = this.state;
        if (currentlySelectedLoaded) {
            return (
                <StyledForm onSubmit={this.updateLessonInfo}>
                    <Row>
                        <InputWrapper cols={2}>
                            <p>Lesson Name</p>
                            <textarea
                                name="title"
                                id="title"
                                cols={40}
                                rows={6}
                                className="custom-textfield lb-textfield"
                                style={{ height: "100px" }}
                                data-arg="name"
                                onChange={this.changeLessonName}
                            >{currentlySelectedCourse.Name}</textarea>
                        </InputWrapper>
                        <InputWrapper cols={2}>
                            <p>Description</p>
                            <textarea
                                name="title"
                                id="title"
                                cols={30}
                                rows={6}
                                className="custom-textfield lb-textfield"
                                style={{ height: "100px" }}
                                data-arg="Description"
                                onChange={this.changeLessonDescription}
                            >{currentlySelectedCourse.Description}</textarea>
                        </InputWrapper>
                    </Row>
                    <Button onClick={this.updateLessonInfo}>Update</Button>
                </StyledForm>
            )
        } else {
            return <p>Loading Lesson Info...</p>
        }
    }

    render() {
        if(this.state.toLogin) {
            return <Redirect to='/login' />
        }
        return (
            <div style={{ minHeight: "100vh", backgroundColor: "#467d7460" }}>
                <Navbar logoutParent={this.onLogout} />
                <ToastContainer />
                {/* <Header>
                    <p style={{ paddingLeft: '10%', color: '#fff' }} className="go-back" onClick={this.onGoBack}>&lt; Back</p>
                </Header> */}
                <Body>
                    <Container>
                        <ScreensList style={{marginTop: '2em'}}>
                            {/* list coming */}
                            {this.renderLessonsList()}
                            <Button onClick={this.toggleNewLessonForm}>ADD LESSON</Button>
                        </ScreensList>
                        <BuilderContainer>
                            <Animated style={{ width: '100%' }} animationIn="slideInUp" animationOut="slideOutRight" animationInDelay={200} isVisible={this.state.showForm}>

                                {this.state.showNewForm ? this.renderNewLessonForm() : ''}
                                {this.state.showInfoForm ? this.renderLessonInfoForm() : ''}
                            </Animated>
                        </BuilderContainer>
                    </Container>
                </Body>
            </div>
        )
    }
}

export default withServices(CourseBuilder);



// WEBPACK FOOTER //
// ./src/pages/Admin/Courses/NewCourseView/CourseBuilder.component.jsx